module.exports = __webpack_public_path__ + "shareImg.657e2d19.png";